import { themeShadows } from './themeColors';

export const components = {
  MuiTable: {
    styleOverrides: {
      root: {
        tableLayout: 'fixed'
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      head: {
        fontSize: '12px',
        fontWeight: 600,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: 'var(--table-head-text)',
        backgroundColor: 'var(--table-head-bg)',
        padding: '12px 8px'
      },
      root: {
        fontSize: '16px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
        padding: '12px 8px 12px 0px'
      }
    }
  },
  MUIDataTableSelectCell: {
    styleOverrides: {
      root: {
        paddingLeft: 12
      }
    }
  },
  MUIDataTableHeadCell: {
    styleOverrides: {
      root: {
        paddingLeft: 16
      }
    }
  },
  MUIDataTableBodyCell: {
    styleOverrides: {
      root: {
        paddingLeft: 8
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        fontSize: '16px',
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: 8
      },
      contained: {
        boxShadow: '0 1px 2px rgba(2, 132, 199, 0.25)',
        '&:hover': {
          boxShadow: '0 4px 12px -2px rgba(2, 132, 199, 0.35)'
        }
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: {
      '*': {
        boxSizing: 'border-box'
      },
      html: {
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        height: '100%',
        width: '100%'
      },
      body: {
        height: '100%'
      },
      a: {
        textDecoration: 'none',
        color: 'inherit'
      },
      '#root': {
        height: '100%'
      },
      '#nprogress .bar': {
        zIndex: '2000 !important'
      }
    }
  },
  MuiFab: {
    styleOverrides: {
      root: {
        boxShadow: themeShadows[12]
      }
    }
  },
  MuiAccordion: {
    styleOverrides: {
      root: {
        '&:before': {
          display: 'none'
        }
      }
    }
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        fontSize: '12px',
        borderRadius: 6,
        backgroundColor: '#0f172a'
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        fontSize: '0.875rem'
      }
    }
  },
  MuiExpansionPanel: {
    styleOverrides: {
      root: {
        '&:before': {
          display: 'none'
        }
      }
    }
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        border: '1px solid var(--border)',
        boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.04) !important'
      }
    }
  }
};
